import { AxiosError } from 'axios';
import Messages from '../config/messages.constants';
/**
 * Get Error Message from Error object
 * @param {unknown} error the error object from server
 */
export function getErrorMessage(error: unknown) {
    const axiosError = error as AxiosError<{ message?: string }>;
    let message;
    if (!navigator.onLine) {
        message = Messages.NO_INTERNET;
    } else if (axiosError?.response?.data?.message) {
        message = axiosError.response.data.message;
    } else {
        message = Messages.UNKNOW_ERROR;
    }
    return message;
}
export function getErrorStatus(error: unknown) {
    return (error as AxiosError)?.response?.status;
}
